import { FuseSidebarModule } from '@fuse/components/index';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormComponentComponent } from './form-component.component';
import { FormComponentService } from './form-component.service';
import { ControlTemplateModule } from '../control-template/control-template.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgSummernoteModule } from '../ng-summernote/ng-summernote.module';
import { PositionModule } from '../control-template/position/position.module';
import { MaterialModule } from '@fuse/material.module';
import { AllFieldsViewModule } from '../all-fields-view/all-fields-view.module';
import { FormRulesService } from '../../services/rules/form-rules.service';
import { ProviderServiceSelectionModule } from '../../components/hard-coded-forms/provider-service-selection/provider-service-selection.module';
import { ClientOrderPaymentModule } from '../../components/hard-coded-forms/client-order-payment/client-order-payment.module';
import { ClientServiceSelectionModule } from '../../components/hard-coded-forms/client-service-selection/client-service-selection.module';
import { ProcessStatusModule } from '../control-template/process-status/process-status.module';
import { AgentProposalBuilderModule } from '../../components/hard-coded-forms/agent-proposal-builder/agent-proposal-builder.module';
import { ClientProposalBuilderModule } from '../../components/hard-coded-forms/client-proposal-builder/client-proposal-builder.module';
// import { BreadcrumbModule } from 'angular2-crumbs/lib';


@NgModule({
  imports: [
    CommonModule,
    ControlTemplateModule,
   FuseSharedModule,
    MaterialModule,
    NgSummernoteModule,
    PositionModule,
    FuseSidebarModule,
    AllFieldsViewModule,
    ProviderServiceSelectionModule,
    ClientServiceSelectionModule,
    ClientOrderPaymentModule,
    AgentProposalBuilderModule,
    ClientProposalBuilderModule,
    ProcessStatusModule,
    // CalenderModule    
    // BreadcrumbModule,
  ],
  declarations: [
    FormComponentComponent
  ],
  providers: [
    FormComponentService,
    FormRulesService
  ],
  exports: [
    FormComponentComponent
  ]
})
export class FormComponentModule { }
